import { useEffect } from "react";

export default function SEO({
  title,
  description,
  canonical,
  image
}) {
  useEffect(() => {
    /* ================= TITLE ================= */
    if (title) {
      document.title = `${title} | BlogySports`;
    }

    /* ================= META DESCRIPTION ================= */
    if (description) {
      let metaDescription = document.querySelector("meta[name='description']");
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute("content", description);
    }

    /* ================= ROBOTS ================= */
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    /* ================= CANONICAL ================= */
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    /* ================= OPEN GRAPH ================= */
    const setMeta = (property, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[property='${property}']`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("property", property);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setMeta("og:title", title);
    setMeta("og:description", description);
    setMeta("og:type", "website");
    setMeta("og:url", canonical);
    setMeta("og:image", image);

    /* ================= TWITTER ================= */
    const setTwitter = (name, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[name='${name}']`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setTwitter("twitter:card", "summary_large_image");
    setTwitter("twitter:title", title);
    setTwitter("twitter:description", description);
    setTwitter("twitter:image", image);

    /* ================= ORGANIZATION SCHEMA ================= */
    let schema = document.getElementById("org-schema");
    if (!schema) {
      schema = document.createElement("script");
      schema.type = "application/ld+json";
      schema.id = "org-schema";
      document.head.appendChild(schema);
    }

    schema.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "BlogySports",
      url: "https://blogysports.com",
      logo: "https://blogysports.com/logo-blogysports.png"
    });

  }, [title, description, canonical, image]);

  return null;
}
